import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, isDesktop } from '../../lib/ep.js';
import { size as _size } from 'lodash';

import { SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import { AlertMessage } from '../builder/Message';
import Spinner from '../builder/Spinner';

import FloatingLayerPublic from './FloatingLayerPublic';
import LeveledHTMLText from './helpers/LeveledHTMLText.js';

class InstagramMediaPicker extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			media_type:props.media_type,
			next:false,
			previous:false,
			first_load:true,
			display_usage_layer:false,
			last_id:false,
			hashtag: (props.hashtag != undefined && props.hashtag != false) ? props.hashtag.replace("#", "").toLowerCase() : false,
			history:[false],
			is_loading:false,
			is_logged:(props.user.id!= undefined) ? props.user.id : false,
			no_more_calls:false,
			page_number:1,
			selected_media:false,
			show:true,
			visible_media:false,
			reseting:false,
		}

		this.max_pages = 3;
	}

	componentDidMount() {
		this.getMedia();
	}

	resetMedia() {
		$('#UserMediainstagram').val('');
		$('#UserMediainstagramCdn').val('');
		$('#UserMediainstagramType').val('');
		$('#UserComment').val('');
		this.setState({ reseting:true,selected_media:false });
		setTimeout(()=>{


			this.setState({visible_media:false,reseting:false });
		},1000)
	}

	toggleUsageLayer() {
		this.setState({ display_usage_layer:!this.state.display_usage_layer });
	}

	getMedia(direction) {
		if(this.state.media_type == 'photo' || this.state.media_type == 'image') {
			$('.field_UserPicture').hide();
		}

		if(this.state.media_type == 'video') {
			$('#mediacontainer').hide();
		}

		if(this.state.media_type == 'both') {
			$('#mediacontainer').hide();
		}

		this.setState({ is_loading:true });
		var data = {};

		//If there is a hashtag ask for it
		if(this.state.hashtag) {
			data.hashtag = this.state.hashtag;
		}

		if((direction == undefined) || (this.state.page_number < this.max_pages && direction > 0) || (this.state.page_number > 1 && direction < 0)) {

			var cursor = '';
			if(this.state.next || this.state.previous){
				cursor = (direction>0) ? direction+'/'+this.state.next : direction+'/'+this.state.previous;
			}
			const user = this.props.user;
			$.get('/utils/instagram_media/'+user.id+'/'+cursor, (media) => {
				this.state.no_more_calls = false;


				//Filter by hashtag if needed
				if(this.state.hashtag) {
					media.elements = media.elements.filter((obj) => {return (obj.name.indexOf(this.state.hashtag) != -1)});

					if(_size(media.elements) == 0) {
						this.reason = 'hashtag';
					}
				} else if(this.state.media_type != 'both') {
					/*media.elements = media.elements.filter(p => (
						p.type == this.state.media_type
					));*/

					if(_size(media.elements) == 0) {
						this.reason = this.state.media_type;
					}
				} else if(_size(media.elements) == 0) {
					// reached the end of catalogue
					this.setState({ no_more_calls:true });
				}

				if(!this.state.no_more_calls) {
					//Limit to 9
					//media.elements =media.elements.slice(0, 9);

					this.setState({
						media,
						first_load:false,
						next:media.next != undefined ? media.next : false,
						previous:media.previous != undefined ? media.previous : false,
						page_number:((direction != undefined) ? this.state.page_number + direction : this.state.page_number),
					});
				}
				var t = setTimeout(() => { this.setState({ is_loading:false }); }, 200);
			},'JSON');
		}
	}

	getPrev() {
		this.getMedia(-1);
	}

	getNext() {
		this.getMedia(1);
	}

	selectFromIG() {
		this.setState({ show:true });
		$('.field_UserPicture').hide();
		$('.field_UserMediaIG').hide();
		$('#mediacontainer').hide();
	}

	selectFromDevice() {
		$('.field_UserPicture').show();
//		$('.field_UserMediaIG').hide();
		this.setState({ show:false });
		if(this.props.onClose) this.props.onClose();
	}

	setPicture(p, type) {
		const url = p.link
		var media = url+'media';
		$('#UserMediainstagram').val(url);
		$('#UserMediainstagramCdn').val(p.picture);
		$('#UserMediainstagramType').val(type);

		var comment = $('#UserComment');

		if(comment.length > 0) {
			$('#UserComment').val(p.name);
		}

		this.setState({
			selected_media:true,
			visible_media:p.picture,
		});

		if(this.props.onSelect != undefined) this.props.onSelect()
	}

	connect() {
		window.location = `/utils/social/instagram/login/${this.props.promotion_id}?rurl=${window.location.href}`;
	}

	logout() {
		window.location = '/utils/social/instagram/logout?rurl=' + window.location.href;
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const import_media_from_network = true;

		const first_page = (this.state.media != undefined && this.state.media != false && this.state.media.elements.length > 0) ? true : false;
		const media_label = (this.props.media_label != undefined) ? this.props.media_label : "Upload image";

		const has_pictures = (!(this.state.media != undefined && this.state.media != false && this.state.media.elements.length == 0)) ? true : false;
		const username = this.props.user.username != undefined ? this.props.user.username :false;

		const ua = navigator.userAgent.toLowerCase();
		const isAndroid = (ua.indexOf("android") > -1) ? true : false;

		const hashtag_visible = this.props.hashtag.replace("#", "");

		var intent = false;
		if(window.platform_so != undefined && !isDesktop()) {
			if(window.platform_so == 'android') {
				intent = `intent://instagram.com/_u/${username}/#Intent;package=com.instagram.android;scheme=https;end`;
			} else if(window.platform_so = 'ios') {
				intent = `instagram://user?username=${username}`;
			}
		}

		if(!import_media_from_network) return null;

		const privacy_policy = (this.props.privacy_policy != undefined) ? this.props.privacy_policy : false;

		if(!this.state.show) {
			return (
				<ActionLink _class={{other:'pick_from_ig'}} onClick={() => this.selectFromIG()}>Pick from Instagram</ActionLink>
			)
		}

		if(!this.state.is_logged) {
			return (
				<ActionLink _class={{icon:'ep-instagram', other:'logged_user'}} onClick={() => this.connect()}>Connect your Instagram account</ActionLink>
			)
		}

		return (
			<div class="field_UserMediaIG">
				{(this.props.user.username != undefined) && (
					<div class="is_logged_sn">
						<FormattedMessage id="Logged as {username}" values={{username:<ActionLink _href={'https://www.instagram.com/' + this.props.user.username} _target="_blank" _class={{other:'logged_user ep-instagram'}}>{this.props.user.username}</ActionLink>}} />

						<ActionLink onClick={() => this.logout()}>Change</ActionLink>

					</div>
				)}
				<div class="is_logged_sn"><FormattedMessage id="Displaying posts with hashtag {hashtag}" values={{hashtag:<strong>#{hashtag_visible}</strong>}} /></div>
				{(this.props.usage) && (
					<ActionLink _class={{other:'from_device', in_top:false}} onClick={() => this.toggleUsageLayer()}>How will we use your photo?</ActionLink>
				)}

				{(!this.state.selected_media && !this.state.hashtag) && (
					<ActionLink _class={{other:'from_device', in_top:false}} onClick={() => this.selectFromDevice()}>Select from your device</ActionLink>
				)}

				{(this.state.media && !this.state.selected_media || this.state.first_load) && (
					<div class={'gui_instagram_gallery' + ((this.state.is_loading) ? ' is_loading' : '')}>
						{(!has_pictures && this.reason == 'hashtag') && (
							<AlertMessage
								_class={{ other:'in_top in_bottom' }}
							>
								<p><FormattedMessage id="You don't have any posts with the hashtag {query}." values={{query:<strong>#{hashtag_visible}</strong>}} /></p>
								<ol>
									{(intent) && (
										<li><ActionLink _class={{other:'redColor'}} _href={intent} _target="_blank">Go to Instagram app</ActionLink></li>
									)}
									<li><FormattedMessage id="Share a photo on your Instagram profile with the hashtag {query}" values={{query:<span>#{hashtag_visible}</span>}} /></li>
									<li><span>{i18n("REFRESH this page and select your contest photo")}</span></li>
								</ol>
							</AlertMessage>
						)}

						{(!has_pictures && this.reason == 'video') && (
							<div>{i18n("There are no videos in your last uploads.")}</div>
						)}

						<ul class="gui_ig_gallery">
							{!this.state.first_load && this.state.media.elements.map((p, i) => {
								const is_disabled =  ((this.state.media_type != 'both' && this.state.media_type != p.type) || (this.state.hashtag && p.name.indexOf(this.state.hashtag) == -1)) ? true : false;

								var media_class = ['is_'+p.type];
								if(is_disabled) media_class.push('is_disabled');

								return (
									<li key={i} class={media_class.join(" ")} style={{backgroundImage:'url('+p.picture+')'}} onClick={() => (!is_disabled) ? this.setPicture(p, p.type) : null}>
										<img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" />
									</li>
								)
							})}

							{(!this.state.first_load && this.state.media.elements.length === 1 && !this.state.selected_media) && (
								<li class="select_media_message">
									<p class="knk-arrow-l-big">{i18n("Click on the image to select it")}</p>
								</li>
							)}
						</ul>

						{(this.state.previous  || this.state.next) && (
							<nav class="gui_navigate_to_slide">
								<SquaredButton
									disabled={(!this.state.previous) ? true : false}
									color="transparent"
									icon='knk-arrow-l-big'
									_class={{ other:'go_prev' }}
									onClick={() => this.getPrev()}
									aria-label="Go previous page"
								/>

								<SquaredButton
									disabled={(!this.state.next || this.state.page_number >= this.max_pages) ? true : false}
									color="transparent"
									icon='knk-arrow-r-big'
									_class={{ other:'go_next' }}
									onClick={() => this.getNext()}
									aria-label="Go next page"
								/>
							</nav>
						)}

						{(this.state.is_loading) && (
							<Spinner>Fetching pictures</Spinner>
						)}
						{(this.state.reseting) && (
							<Spinner>Removing selection</Spinner>
						)}
					</div>
				)}

				{(this.state.selected_media) && (
					<div class="gui_instagram_gallery is_selected_media">
						<ul class="gui_ig_gallery">
							<li id="gui_selected_media" style={{backgroundImage:'url('+this.state.visible_media+')'}}>
								<img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" />
								<span class="selected_tick ep-ok"></span>
							</li>
							<li class="change_image" onClick={() => this.resetMedia()}>
								<div class="knk-reload">
									<img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" />
								</div>
							</li>
						</ul>
					</div>
				)}

				{(this.props.usage && this.state.display_usage_layer) && (
					<FloatingLayerPublic
						title={`<h1>${i18n("How will we use your photo?")}</h1>`}
						backButton={() => this.toggleUsageLayer()}
					>
						<LeveledHTMLText>
							<p dangerouslySetInnerHTML={{ __html:this.props.usage }} />
						</LeveledHTMLText>

						{(privacy_policy) && (
							<ul class="related_link original_color_item">
								<li class="link">
									<FormattedMessage id="You will find more information in our {link}." values={{link:<ActionLink _href={privacy_policy} _target="_blank">Privacy policy</ActionLink>}} />
								</li>
							</ul>
						)}
					</FloatingLayerPublic>
				)}
			</div>
		)
	}
}

export default injectIntl(InstagramMediaPicker);